import React, { useState } from "react";
import {
  Box,
  Container,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
} from "@mui/material";
import { useSelector } from "react-redux";
import {
  Facebook,
  LinkedIn,
  Twitter,
  Email,
  YouTube,
} from "@mui/icons-material";

const Fotter = () => {
  const [openSpeedDial, setOpenSpeedDial] = useState(true);

  const { developer } = useSelector((state) => state.developers);
  const { socials } = developer;
  const socialIcons = [
    { icon: <YouTube />, name: "Copy" },
    { icon: <Facebook />, name: "Save" },
    { icon: <LinkedIn />, name: "Print" },
    { icon: <Twitter />, name: "Share" },
  ];

  return (
    <>
      <Container>
        <Box>
          <Box sx={{ height: 320, transform: "translateZ(0px)", flexGrow: 1 }}>
            <SpeedDial
              ariaLabel="SpeedDial controlled open example"
              sx={{ position: "absolute", bottom: 16, right: 16 }}
              icon={<SpeedDialIcon />}
              onClose={() => setOpenSpeedDial(false)}
              onOpen={() => setOpenSpeedDial(true)}
              open={openSpeedDial}
            >
              {socials.map((social) => {
                if (social?.attributes?.handle === "facebook") {
                  return (
                    <SpeedDialAction
                      key={social?.attributes?.handle}
                      icon={<Facebook />}
                      tooltipTitle={social?.attributes?.handle}
                      href={social?.attributes?.profile_url}
                    />
                  );
                }
                if (social?.attributes?.handle === "youtube") {
                  return (
                    <SpeedDialAction
                      key={social?.attributes?.handle}
                      icon={<YouTube />}
                      tooltipTitle={social?.attributes?.handle}
                      href={social?.attributes?.profile_url}
                    />
                  );
                }
                if (social?.attributes?.handle === "twitter") {
                  return (
                    <SpeedDialAction
                      key={social?.attributes?.handle}
                      icon={<Twitter />}
                      tooltipTitle={social?.attributes?.handle}
                      href={social?.attributes?.profile_url}
                    />
                  );
                }
                if (social?.attributes?.handle === "linkedIn") {
                  return (
                    <SpeedDialAction
                      key={social?.attributes?.handle}
                      icon={<LinkedIn />}
                      tooltipTitle={social.attributes.handle}
                      href={social?.attributes?.profile_url}
                    />
                  );
                }
              })}
            </SpeedDial>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Fotter;
